// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chats',
  new_chat: 'Ny chat',
  note: {
    team: 'Alles chats på {{restaurant}}: dine egne, dit teams og restaurantens.',
    own: 'Dine chats på {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant: 'Dine chats uden valgt restaurant. En chat flyttes til en restaurants chats, når du vælger den.',
  },
  log: 'Alle forespørgsler i Amigo-loggen',
  days: {
    today: 'I dag',
    yesterday: 'I går',
    earlier: 'Tidligere',
  },
  who: {
    you: 'Dig',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Ejer',
      staff: 'Personale',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Færdig',
    answered: 'Besvaret',
    waiting: 'Afventer godkendelse',
    partial: '{{applied}} af {{total}} udført',
    rejected: 'Afvist',
    not_yet: 'Kunne ikke gøres endnu',
    failed: 'Mislykkedes',
  },
  none: {
    title: 'Ingen chats endnu for {{restaurant}}',
    title_no_restaurant: 'Ingen chats endnu uden valgt restaurant',
    text: 'Chats, du starter her, bliver her, så du kan vende tilbage til dem.',
  },
  loading: 'Indlæser chats…',
  loading_more: 'Indlæser flere chats…',
  load_failed: 'Chats kunne ikke indlæses.',
  retry: 'Prøv igen',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nyt svar:',
  new_answers_other: 'Nye svar:',
};
